import { createStore } from "vuex";

import home from "./home.module";
import auth from "./auth.module";
import article from "./article.module";
import profile from "./profile.module";
import decorations from "./decorations.module";
import adminOptions from "./adminOptions.module";
import decorationMethod from "./decorationmethod.module";
import rollupFees from "./rollupFees.module";
import ecommDisplayNames from "./ecommDisplayNames.module";
import splitShipment from "./splitShipment.module";
import account from "./account.module";

export default createStore({
    modules: {
        home,
        auth,
        article,
        profile,
        decorations,
        adminOptions,
        decorationMethod,
        rollupFees,
        ecommDisplayNames,
        splitShipment,
        account
    }
});
